import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import bg from '../../Images/newbg.png';
import AuthPanel from '../AuthPanel';

/**
 * AuthLayout — full-page wrapper: background image + left panel.
 * Background is on a separate layer so blur doesn't affect the card.
 */
const AuthLayout = ({ children }) => (
  <Box sx={{
    height: '100vh',
    width: '100vw',
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
    overflowX: 'hidden',
  }}
  >

    {/* Blurred background — isolated layer, does not affect card or text */}
    <Box
      sx={{
        position: 'absolute',
        inset: '-10px',
        backgroundImage: `url(${bg})`,
        backgroundSize: '120%',
        backgroundPosition: 'center',
        filter: 'brightness(0.75)',
        zIndex: 0,
      }}
    />

    {/* Subtle translucent overlay on the left side */}
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: { xs: '0%', md: '45%' },
        height: '100%',
        backgroundColor: '#FFFFFF',
        opacity: 0.06,
        pointerEvents: 'none',
        display: { xs: 'none', md: 'block' },
        zIndex: 1,
      }}
    />

    {/* Left info panel */}
    <Box sx={{
      flex: '0 0 40%',
      display: { xs: 'none', md: 'flex' },
      alignItems: 'center',
      justifyContent: 'flex-start',
      position: 'relative',
      zIndex: 2,
    }}
    >
      <AuthPanel />
    </Box>

    {/* Right side — card */}
    <Box sx={{
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      px: { xs: '16px', md: '40px' },
      py: { xs: '24px', md: '16px' },
      overflowY: 'auto',
      overflowX: 'hidden',
      position: 'relative',
      zIndex: 2,
    }}
    >
      {children}
    </Box>

  </Box>
);

AuthLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthLayout;
